import { useColorMode } from "@chakra-ui/react";

import UserTypeSelector from "./components/UserTypeSelector";
import { useLogin } from "./useLogin";
import { DevLoginPanel } from "./DevLoginPanel";

// O login do candidato migrou para o portal próprio (starter-pack). Aqui, no
// GG Hub interno, "Sou candidato" apenas REDIRECIONA para esse portal — o app
// interno não hospeda mais a auth/trilha do candidato.
const CANDIDATE_PORTAL_URL = import.meta.env.VITE_CANDIDATE_PORTAL_URL ?? "";

export const LoginPage = () => {
  const { login, error } = useLogin();
  const { colorMode } = useColorMode();

  const isDark = colorMode === "dark";

  return (
    <>
      <UserTypeSelector
        dark={isDark}
        onCollaboratorLogin={login}
        onCandidateClick={() => {
          if (CANDIDATE_PORTAL_URL) window.location.href = CANDIDATE_PORTAL_URL;
        }}
        googleError={error}
      />
      {/* Removido do bundle de produção pelo Vite (import.meta.env.DEV). */}
      {import.meta.env.DEV && <DevLoginPanel />}
    </>
  );
};
